import React, { useEffect, useState } from "react";
import DataTable from 'react-data-table-component';
import { fetchAllNotificationGate } from "../../resources/NotificationResource";
import { format } from "date-fns";
import { getLocalAuth } from "../../utils/AuthUtils";
import ErrorNotFound from "../errors/Error";
import io from 'socket.io-client';
import { showErrorToast } from "../../utils/GlobalToast";
import { baseUrl } from "../../constants/Constant";

const NotificationGate = () => {
  const socket = io(baseUrl);
  const values = getLocalAuth()
  const privilege = JSON.parse(values.authPrivilege);

  let dataPrivilege = privilege.data.menu.filter(data => {
    return data.code === "Notification Gate"
  });

  let dataRead = dataPrivilege.length === 0 ? [] : dataPrivilege[0].action_page.filter(data => {
    return data.code === "Read"
  });

  const [dataNotificationGate, setDataNotificationGate] = useState([]);
  const [dateFilter, setDateFilter] = useState(format(new Date(), "yyyy-MM-dd").toString());
  const [refreshKey, setRefreshKey] = useState(0);

  const fetchNotificationGate = () => {
    fetchAllNotificationGate(dateFilter === "" ? "" : format(dateFilter, "yyyy-MM-dd").toString())
      .then((res) => {
        setDataNotificationGate(res.data);
      })
      .catch((err) => {
        setDataNotificationGate([]);
      });
  };

  useEffect(() => {
    fetchNotificationGate();
    socket.once('alert', (alert) => {
      showErrorToast(alert);
      setRefreshKey(refreshKey => refreshKey + 1);
    });

    // return () => {
    //   socket.disconnect();
    // };
    // eslint-disable-next-line
  }, [refreshKey]);

  const columns = [
    {
      name: 'No',
      cell: (row, index) => index + 1,
      width: '60px'
    },
    {
      name: 'Gate',
      selector: row => row.gate === null ? '-' : row.gate,
      sortable: true,
    },
    {
      name: 'RFID No',
      selector: row => row.rfid === null || typeof row.rfid === 'undefined' ? '-' : row.rfid.rfid_number,
      sortable: true,
    },
    {
      name: 'RFID Name',
      selector: row => row.rfid === null || typeof row.rfid === 'undefined' ? '-' : row.rfid.name,
      sortable: true,
    },
    {
      name: 'Part No',
      selector: row => row.part_number === null || typeof row.part_number === 'undefined' ? '-' : row.part_number,
      sortable: true,
    },
    {
      name: 'Part Name',
      selector: row => row.part_name === null || typeof row.part_name === 'undefined' ? '-' : row.part_name,
      sortable: true,
    },
    {
      name: 'Batch',
      selector: row => row.batch === null || typeof row.batch === 'undefined' ? '-' : row.batch,
      sortable: true,
    },
    {
      name: 'QTY',
      selector: row => row.qty === null || typeof row.qty === 'undefined' ? '-' : row.qty,
      sortable: true,
    },
    {
      name: 'Port',
      selector: row => row.port,
      sortable: true,
    },
    {
      name: 'Mux',
      selector: row => row.mux,
      sortable: true,
    },
    {
      name: 'RSSI',
      selector: row => row.rssi,
      sortable: true,
    },
    {
      name: 'Created At',
      selector: row => row.created_at === null ? '-' : format(row.created_at, "yyyy-MM-dd HH:mm").toString(),
      sortable: true,
      width: '180px'
    },
    {
      name: 'Updated At',
      selector: row => row.updated_at === null ? '-' : format(row.updated_at, "yyyy-MM-dd HH:mm").toString(),
      sortable: true,
      width: '180px'
    },
  ];
  return (
    <div>
      {dataRead.length === 0 ? <ErrorNotFound /> : !dataRead[0].is_active ? <ErrorNotFound /> :
        <div className="page-content-wrapper">
          <div className="page-content">
            <div className="card">
              <div className="card-body">
                <div className="card-title">
                  <h4 className="mb-0">Notification Gate</h4>
                </div>
                <hr />
                <div className="row">
                  <div className="col-md-3">
                    <label className="form-label">Scan Date:</label>
                    <input type="date" className="form-control" value={dateFilter} onChange={(e) => {
                      setDateFilter(e.target.value);
                      setRefreshKey(refreshKey => refreshKey + 1);
                    }} />
                  </div>
                </div>
                <br />
                <div className="table-responsive">
                  <DataTable
                    columns={columns}
                    data={dataNotificationGate}
                    pagination
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  );
}

export default NotificationGate;